import React, { useEffect, useState, useRef, useMemo } from "react";
import useAxios from "../../utils/useAxios";
import * as tus from "tus-js-client";
import { hideModal, showModal } from "../../utils/modalUtility";
import { useAppContext } from "../../context/AppContext";
// import io from "socket.io-client";
// import config from "../../config";
// import { io } from "socket.io-client";
// import { jwtDecode } from "jwt-decode";

// const socket = io("http://localhost:5000");

function Conversation() {
  const [users, setUser] = useState([]);
  const [chatDonorGroup, setChatDonorGroup] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedGroupUser, setSelectedGroupUser] = useState(null);
  const [mediaFile, setMediaFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [receiverId, setReceiverId] = useState(null);
  const [groupId, setGroupId] = useState(null);
  const [loading, setLoading] = useState(false); // To track loading state

  const [senderId, setSenderId] = useState(null);
  const [message, setMessages] = useState([]);
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0); // Track progress
  const [isUploading, setIsUploading] = useState(false); // Track if upload is ongoing

  const [selectedItems, setSelectedItems] = useState([]);
  const [mediaType, setMediaType] = useState(""); // 'image' or 'video'
  const [newMessage, setNewMessage] = useState("");
  const [selectedPreview, setSelectedPreview] = useState(null); //  preview URL
  const [selectedPost, setSelectedPost] = useState(null);
  const [activeTab, setActiveTab] = useState("donor");
  const [myId, set_myId] = useState(null);
  const [role, setRole] = useState(null);

  const [gridPosition, setGridPosition] = useState("row");
  const [broadcastMessages, setBroadcastMessages] = useState([]); // New state for broadcast messages

  const debounceTimeout = useRef(null); // store the timeout reference

  const axiosAPI = useAxios();
  const { state } = useAppContext();

  // Establish Socket.IO connection to the server
  // const url = config.apiBaseUrl;
  // const socket = io(url);

  // useEffect(() => {
  //   // Listen for new messages from the server (emitted by io.to(receiver_id))
  //   socket.on("newMessage", (message) => {
  //     console.log("message",message)
  //     setMessages((prevMessages) => [...prevMessages, message]);
  //     console.log("Connected")
  //   });

  //   // Clean up the listener when the component unmounts
  //   return () => {
  //     socket.off("newMessage");
  //   };
  // }, []);

  // function setConnection(id) {
  //   const socket = io(url, {
  //     query: {
  //       userId: id, //  This is receiver_id in your case
  //     },
  //   });
  // }

  const selectMediaFileToSend = (
    index,
    thumbnail_url,
    media_url,
    media_type,
  ) => {
    if (selectedItems.includes(index)) {
      setSelectedItems([]);
      setSelectedPreview(null);
    } else {
      setSelectedItems([index]);
      setSelectedPreview({
        thumbnail_url,
        media_url,
        media_type,
      });

      // console.log("Selected Preview Set:", {
      //   thumbnail_url,
      //   media_url,
      //   media_type,
      // });
    }
  };

  // const getUserIdFromToken = () => {
  //   const token = localStorage.getItem("accessToken"); // or cookie, wherever you stored it

  //   if (!token) return null;

  //   try {
  //     const decoded = jwtDecode(token);
  //     console.log("user id ",decoded.user_id)
  //     return decoded.user_id; //  Make sure your token has this key
  //   } catch (err) {
  //     console.error("Invalid token");
  //     return null;
  //   }
  // };

  // useEffect(() => {
  //   const user_id = getUserIdFromToken();

  //   console.log("user",user_id)

  //   if (user_id) {
  //     socket.emit("register", user_id);

  //     socket.on("receive-message", (message) => {
  //       console.log("message receive from backend",message)
  //       if (message.receiver_id === user_id) {
  //         setMessages((prev) => [...prev, message]);
  //       }
  //     });
  //   }

  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);

  function changeGridHandler(type) {
    if (type === "rows") {
      setGridPosition("row");
    } else {
      setGridPosition("column");
    }
  }

  // Get All  User
  const getUsers = async (value = "") => {
    try {
      const url = value.trim()
        ? `/api/conversation/get-conversation-user?search=${value}&limit=20&page=1`
        : `/api/conversation/get-conversation-user?limit=20&page=1`;

      // const response = await axiosAPI.get(
      //   `/api/conversation/get-conversation-user?search=${value}&page=1&limit=20`
      // );

      const response = await axiosAPI.get(url);
      // console.log("Reponse", response.data.results);
      setUser(response.data.results);
      //   setLoading(false);
    } catch (error) {
      console.error(error);
      //   setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Clear previous timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Set new debounce timer

    debounceTimeout.current = setTimeout(() => {
      getUsers(value.trim());
    }, 400);
  };

  const filteredUsers = useMemo(() => {
    return users.filter((user) => {
      // const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
      const fullName = `${user.full_name}`.toLowerCase();
      return fullName.includes(searchTerm.toLowerCase());
    });
  }, [users, searchTerm]);

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string

    setRole(state?.user?.role);
  }, []);

  //  Get chat Group Donor
  const getDonorGroup = async () => {
    try {
      const response = await axiosAPI.get("/api/conversation/get-donor-group");
      // console.log("Response",response)
      setChatDonorGroup(response.data.donors);
      //   setLoading(false);
    } catch (error) {
      console.error(error);
      //   setLoading(false);
    }
  };

  // console.log("Filtered users", filteredUsers);

  function resetField() {
    setNewMessage("");
    setPreviewUrl("");
  }

  // New function to upload large video file
  const uploadLargeVideo = async (
    videoId,
    presigned_signature,
    current_file = null,
  ) => {
    const library_id = "409106";
    const expiration_time = Math.floor(Date.now() / 1000) + 200000;

    // console.log("mediaFile: ", mediaFile);

    // Use the mediaFile directly from the state
    const file = current_file; //  Using the mediaFile state here
    // console.log("File: ", file);

    if (!file) {
      console.error("No file selected for upload.");
      return;
    }

    // Start the upload process
    setIsUploading(true);

    const videoFileUpload = new tus.Upload(file, {
      endpoint: "https://video.bunnycdn.com/tusupload",
      retryDelays: [0, 3000, 5000, 10000, 20000, 60000, 60000],
      headers: {
        AuthorizationSignature: presigned_signature,
        AuthorizationExpire: expiration_time,
        VideoId: videoId,
        LibraryId: library_id,
      },
      metadata: {
        filetype: file.type,
      },
      onError: function (error) {
        console.error("Upload failed:", error);
        setIsUploading(false);
      },
      onProgress: function (bytesUploaded, bytesTotal) {
        const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
        setUploadProgress(percentage);
        // console.log(`${bytesUploaded}/${bytesTotal} uploaded — ${percentage}%`);
      },
      onSuccess: async function () {
        // console.log(" Video upload completed successfully.");
        setIsUploading(false);

        // Proceed to submit the form or send the message
        await insertMediaFile(videoId, "video");

        // Reset the state after upload is successful
        setMediaFile(null);
        setNewMessage(""); // Reset message field if needed
      },
    });

    // Check for previous uploads to resume if any
    const previousUploads = await videoFileUpload.findPreviousUploads();
    if (previousUploads.length) {
      videoFileUpload.resumeFromPreviousUpload(previousUploads[0]);
    }

    videoFileUpload.start();
  };

  const handleSubmit = async () => {
    // console.log("Called");
    // console.log("Selected Preview", selectedPreview);

    if (!newMessage.trim() && !selectedPreview) return;

    // console.log("Text", newMessage);
    // console.log("File", mediaFile);

    setIsSubmitting(true);

    try {
      // 3️ Selected Thumbnail (Preview URL - No Upload)
      // console.log("Select Preview", selectedPreview);
      if (selectedPreview) {
        const selectedPreviewString = JSON.stringify(selectedPreview);
        // console.log("Inside Selected Preview", selectedPreviewString);

        // await handleSendMessage(selectedPreview, "image");
        await handleSendMessage(
          selectedPreviewString,
          selectedPreview.media_type,
        );

        setSelectedItems([]);
        setSelectedPreview(null);
      }

      //  Text only
      else if (newMessage.trim()) {
        await handleSendMessage(newMessage.trim(), "text");
        setNewMessage("");
      }

      setIsSubmitting(false);
    } catch (error) {
      console.error("Chat Send Error:", error);
      setIsSubmitting(false);
    }
  };

  // New function to fetch broadcast messages specifically
  const fetchBroadcastMessages = async () => {
    try {
      const response = await axiosAPI.get(
        "/api/conversation/get-broadcast-messages",
      );

      if (response?.status === 200) {
        const messages = response.data?.messages || [];

        // optional: format for UI consistency
        const formatted = messages.map((msg) => ({
          ...msg,
          is_broadcast: 1,
          sender_name: "Admin",
        }));

        setBroadcastMessages(formatted);
      }
    } catch (error) {
      console.error("Error fetching broadcast messages:", error);
    }
  };
  const handleSendMessage = async (content = "", message_type = "text") => {
    // console.log("Message Type", message_type);

    // console.log("Sender ID", senderId);
    // console.log("Receiver ID", receiverId);

    // console.log("Content", content);
    // console.log("Group id ", groupId);

    // For broadcast messages, admin sends to all users
    // We'll use a special flag in the payload
    const isBroadcast = role === "admin" && !receiverId && !groupId;

    // if (!(content && (receiverId || groupId))) return;
    if (!content) return;

    // return

    try {
      // console.log("Message Type", message_type);

      const payload = {
        // sender_id: senderId,
        receiver_id: isBroadcast ? null : receiverId,
        message_type, // text | media | video
        content: content, // message text OR media url OR videoId
        group_id: groupId,
        is_broadcast: isBroadcast ? 1 : 0, // Send broadcast flag
      };

      // console.log("Payload for sending message:", payload);
      // return

      const response = await axiosAPI.post(
        "/api/conversation/send-message",
        payload,
      );

      // console.log("Response is ",response)

      if (response?.status === 200 || response?.status === 201) {
        // If it's a broadcast, fetch messages to include the new broadcast
        if (isBroadcast) {
          fetchMessages();
          // Also refresh broadcast messages if you have a separate endpoint
          fetchBroadcastMessages();
        } else {
          fetchMessages();
        }
        fetchUploadedMedia();
        resetField();
        hideModal("customModal");
      } else {
        console.error(
          "Message sending failed:",
          response?.data?.message || "Unknown error",
        );
      }
    } catch (error) {
      console.error(
        "Error sending message:",
        error?.response?.data?.message || error.message,
      );
    }
  };

  const formatTime = (timestamp) => {
    // console.log("Time Stamp",timestamp)
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  // console.log("Message", message);

  const openPostModal = (mediaData) => {
    setSelectedPost({
      media_url: mediaData.media_url,
      media_type: mediaData.media_type, // already known, no need to guess
      thumbnail_url: mediaData.thumbnail_url || null,
    });

    showModal("postModal");
  };

  const insertMediaFile = async (content, message_type = "text") => {
    // if (!content || !receiverId) return;

    if (!content) return;

    // console.log("Inside Sender ID", senderId);
    // console.log("Inside Receiver ID", receiverId);

    // console.log("Content", content);

    // return

    try {
      const payload = {
        message_type, // text | media | video
        content, // message text OR media url OR videoId
        is_broadcast: role === "admin" && !receiverId && !groupId ? 1 : 0,
      };

      const response = await axiosAPI.post(
        "/api/conversation/insert-media",
        payload,
      );

      if (response?.status === 200 || response?.status === 201) {
        // console.log(" Message sent:", response.data);
        if (mediaType === "image") {
          // fetchUploadedMedia(); // 🔁 Immediately fetch for images
        } else {
          // console.log("Called");
          setTimeout(() => {
            fetchUploadedMedia(); // ⏱️ Delay fetch for videos
          }, 6000); // Delay for Bunny thumbnail to be ready
        }
        // temperary
        // fetchMessages();
        resetField();
      } else {
        console.error(
          " Message sending failed:",
          response?.data?.message || "Unknown error",
        );
      }
    } catch (error) {
      console.error(
        " Error sending message:",
        error?.response?.data?.message || error.message,
      );
    }
  };

  const handleMediaUpload = async (e) => {
    const file = e.target.files[0];
    // console.log("File ", file);
    if (!file) return;

    setLoading(true); //  Start loader
    setMediaFile(file); // Store file if needed later

    try {
      const formData = new FormData();
      formData.append("media", file);

      let mediaUrl = ""; // Will hold the server response URL

      // Check if the file is an image or video
      if (file.type.startsWith("image/")) {
        // Image upload logic
        const response = await axiosAPI.post(
          `/api/conversation/upload-media`, // Assuming your backend handles image uploads
          formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        );
        mediaUrl = response.data?.imageUrl || file.name;

        await insertMediaFile(mediaUrl, "image");

        // Save uploaded media to state (show preview)
        setUploadedMedia((prev) => [
          {
            thumbnail_url: mediaUrl,
            media_url: mediaUrl,
            media_type: "image",
          },
          ...prev,
        ]);
      } else if (file.type.startsWith("video/")) {
        // Video upload logic
        // Video upload
        const { data } = await axiosAPI.get(`/api/conversation/get-video-id`, {
          params: { user_id: senderId }, // if needed
        });

        const videoId = data.video_id;
        const presigned_signature = data.presigned_signature;

        await uploadLargeVideo(videoId, presigned_signature, file);

        return; // rest is handled in upload success
      }

      // Send message with media URL (either image or video)
      // await handleSendMessage(
      //   mediaUrl,
      //   file.type.startsWith("video/") ? "video" : "image"
      // );

      // console.log("test it runs");

      // Reset state after upload
      // setMediaFile(null);
      // setNewMessage("");
    } catch (error) {
      // console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setLoading(false); //End loader
    }
  };

  // console.log("Message ", message);

  const fetchUploadedMedia = async () => {
    try {
      const response = await axiosAPI.get("/api/conversation/get-media");

      const fetchedMedia = response.data.results || [];

      // const formattedMedia = fetchedMedia
      //   .map((item) => ({
      //     // preview: item.media_url || item.thumbnail_url,
      //     thumbnail_url: item.thumbnail_url,
      //     media_url: item.media_url,
      //     type: item.media_type,
      //     created_at: item.created_at,
      //   }))
      //   .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // latest first

      const formattedMedia = fetchedMedia.map((item) => ({
        // preview: item.media_url || item.thumbnail_url,
        thumbnail_url: item.thumbnail_url,
        media_url: item.media_url,
        media_type: item.media_type,
      })); // latest first

      setUploadedMedia(formattedMedia);
      // console.log("Formatted Media", formattedMedia);
    } catch (error) {
      console.error("Error fetching media:", error);
    }
  };

  // const fetchMessages = async () => {
  //   try {
  //     const user1_id = senderId;
  //     const user2_id = receiverId; // jisko click kiya

  //     const response = await axiosAPI.get(`/api/conversation/get-message`, {
  //       params: {
  //         user1_id,
  //         user2_id,
  //       },
  //     });

  //     if (response.status === 200) {
  //       setMessages(response.data.messages); // Store in state
  //     } else {
  //       console.error("Failed to fetch messages:", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error(
  //       "Error fetching messages:",
  //       error.response?.data || error.message
  //     );
  //   }
  // };

  // const fetchMessages = async () => {

  //     console.log("Fetch message")

  //     try {
  //       if (senderId && receiverId) {
  //         // Donor to donor chat
  //         const response = await axiosAPI.get(`/api/conversation/get-message`, {
  //           params: {
  //             sender_id: senderId,
  //             receiver_id: receiverId,
  //           },
  //         });

  //         if (response.status === 200) {
  //           setMessages(response.data.messages);
  //         } else {
  //           console.error("Failed to fetch messages:", response.data.message);
  //         }
  //       } else if (senderId && groupId) {
  //         // Group chat
  //         const response = await axiosAPI.get(`/api/conversation/get-message`, {
  //           params: {
  //             sender_id: senderId,
  //             receiver_id: groupId,
  //             group_id: groupId,
  //           },
  //         });

  //         if (response.status === 200) {
  //           setMessages(response.data.messages);
  //         } else {
  //           console.error(
  //             "Failed to fetch group messages:",
  //             response.data.message
  //           );
  //         }
  //       } else {
  //         console.warn("Missing senderId and receiverId/groupId");
  //       }
  //     } catch (error) {
  //       console.error(
  //         "Error fetching messages:",
  //         error.response?.data || error.message
  //       );
  //     }
  //   };

  const fetchMessages = async (receiver_id = null) => {
    // console.log("Fetch message");

    let main_receiver_id = null;

    if (receiver_id) {
      main_receiver_id = receiver_id;
    } else {
      main_receiver_id = receiverId;
    }

    try {
      if (main_receiver_id) {
        // Donor-to-donor chat (sender_id will be taken from token on backend)
        const response = await axiosAPI.get(`/api/conversation/get-message`, {
          params: {
            receiver_id: main_receiver_id,
            include_broadcast: true, // Add this parameter to include broadcasts
          },
        });

        if (response.status === 200) {
          setMessages(response.data.messages);
          set_myId(response.data.myId);
        } else {
          console.error("Failed to fetch messages:", response.data.message);
        }
      } else if (groupId) {
        // Group chat
        const response = await axiosAPI.get(`/api/conversation/get-message`, {
          params: {
            receiver_id: groupId, // same as before
            group_id: groupId,
            include_broadcast: true,
          },
        });

        if (response.status === 200) {
          setMessages(response.data.messages);
        } else {
          console.error(
            "Failed to fetch group messages:",
            response.data.message,
          );
        }
      } else {
        console.warn("Missing receiverId or groupId");
      }
    } catch (error) {
      console.error(
        "Error fetching messages:",
        error.response?.data || error.message,
      );
    }
  };

  // console.log("Filter and selected user",filteredUsers,selectedUser)

  // useEffect(() => {
  //   if (senderId && (receiverId || groupId)) {
  //     fetchMessages();
  //   }
  // }, [senderId, receiverId, groupId]);

  // useEffect(() => {
  //   if (receiverId || groupId) {
  //     fetchMessages();
  //   }
  // }, [receiverId, groupId]);

  // console.log("Filter user",filteredUsers)
  // console.log("Message", message);
  // console.log("Group Donor", chatGroupDonor);

  useEffect(() => {
    getDonorGroup();
  }, []);

  // useEffect(() => {
  //   fetchUploadedMedia();
  // }, [senderId, receiverId]); // reload jab users change ho

  useEffect(() => {
    fetchUploadedMedia();
  }, [senderId, receiverId]); // reload jab users change ho

  // useEffect(() => {
  //   getUsers();
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   if (user?.user_id) {
  //     setSenderId(user.user_id);
  //   }
  // }, []);

  useEffect(() => {
    const getSenderIdFromBackend = async () => {
      try {
        const response = await axiosAPI.get("/api/conversation/get-user-id"); // Backend API call to get user ID
        if (response?.data?.user_id) {
          setSenderId(response.data.user_id); // Set the sender ID in the state
        }
      } catch (error) {
        console.error("Failed to fetch sender ID from backend:", error.message);
      }
    };
    getUsers(); // Optional: if you still need to get other user data
    getSenderIdFromBackend(); // Call the function to get sender ID
    // Fetch broadcast messages on component mount
    if (role === "admin") {
      fetchBroadcastMessages();
    }
  }, []);

  // useEffect(()=>{
  //   getUsers(); // Optional: if you still need to get other user data
  // },[searchTerm])

  useEffect(() => {
    // Set the first user as the default selected user when filteredUsers is populated
    if (users.length > 0) {
      setSelectedUser(users[0]);
      setReceiverId(users[0].id);
      fetchMessages(users[0].id);
      setGroupId(null);
    }
  }, [users]); // Dependency array ensures it runs when filteredUsers changes

  // Function to handle user click
  const selectChatHandler = (user, id) => {
    // console.log({ user });
    // setConnection(id);
    setReceiverId(id); // Set the receiver ID]
    setSelectedUser(user); // Set the selected user
    setGroupId(null);
    fetchMessages(id);
  };

  // Function to Group Chat user click
  const selectChatGroupHandler = (group, id) => {
    setSelectedGroupUser(group); // Set the selected user
    // setSelectedUser(group); // Set the selected user
    setReceiverId(null); // Set the receiver ID
    setGroupId(id);
    fetchMessages(id); // Add this to load group messages
  };

  // Helper function to check if a message is a broadcast
  const isBroadcastMessage = (msg) => {
    return msg.is_broadcast === 1 || msg.is_broadcast === true;
  };

  // Get sender name for display
  const getSenderName = (msg) => {
    if (isBroadcastMessage(msg)) {
      return "Admin";
    }
    return msg.sender_name || selectedUser?.full_name || "User";
  };

  // Get message direction
  const getMessageDirection = (msg) => {
    if (isBroadcastMessage(msg)) {
      // Broadcast messages can be shown as "in" for all users
      return "in";
    }
    return msg.receiver_id === myId ? "in" : "out";
  };

  // Render message content
  const renderMessageContent = (msg) => {
    let mediaData = null;
    if (
      (msg.message_type === "image" || msg.message_type === "video") &&
      typeof msg.content === "string" &&
      msg.content.trim().startsWith("{")
    ) {
      try {
        mediaData = JSON.parse(msg.content);
      } catch (error) {
        console.error("Invalid JSON content", error);
      }
    }

    const mediaType = mediaData?.media_type || msg.message_type;
    const mediaUrl = mediaData?.media_url || msg.content;
    const thumbnailUrl = mediaData?.thumbnail_url || mediaUrl;

    if (mediaType === "image") {
      return (
        <img
          className="chat-media-box"
          src={thumbnailUrl}
          alt="sent-image"
          onClick={() =>
            openPostModal({
              media_url: mediaUrl,
              media_type: "image",
              thumbnail_url: thumbnailUrl,
            })
          }
        />
      );
    } else if (mediaType === "video") {
      return (
        <img
          src={thumbnailUrl}
          className="chat-media-box"
          alt="video-thumbnail"
          onClick={() =>
            openPostModal({
              media_url: mediaUrl,
              media_type: "video",
              thumbnail_url: thumbnailUrl,
            })
          }
        />
      );
    } else {
      return <span style={{ color: "#000000" }}>{msg.content}</span>;
    }
  };

  return (
    <div className="container">
      <div className="page-wrapper has-sidebar">
        <div className="page-sidebar bg-white">
          <header className="sidebar-header d-xl-none">
            <a className="back">
              <i className="breadcrumb-icon fa fa-angle-left me-2"></i>Back
            </a>
          </header>

          <div className="page-sidebar-section bg-white pb-3">
            {role === "admin" && (
              <div className="chat-search-header px-4 border-bottom">
                <input
                  type="text"
                  className="form-control chat-search my-3"
                  placeholder="Search..."
                  value={searchTerm}
                  // onChange={(e) => setSearchTerm(e.target.value)}
                  onChange={handleSearch}
                />
              </div>
            )}
            <div className="flex-grow-1 position-relative">
              <nav
                className={`custom-tab-nav ${role === "admin" ? "mt-3" : ""}`}
              >
                {role === "admin" && (
                  <>
                    <button
                      className={`tab-btn ${
                        activeTab === "donor" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("donor")}
                    >
                      Donor
                    </button>
                    <button
                      className={`tab-btn ${
                        activeTab === "group" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("group")}
                    >
                      Donor Group
                    </button>
                    {/* Add Broadcast tab for admin */}
                    <button
                      className={`tab-btn ${
                        activeTab === "broadcast" ? "active" : ""
                      }`}
                      onClick={() => {
                        setActiveTab("broadcast");
                        // Clear selected user/group when viewing broadcast
                        setSelectedUser(null);
                        setSelectedGroupUser(null);
                        setReceiverId(null);
                        setGroupId(null);
                        fetchBroadcastMessages();
                      }}
                    >
                      Broadcast
                    </button>
                  </>
                )}
              </nav>
              <div className="chat-contacts list-group chat-scroll py-2 ps rounded-0">
                {activeTab === "donor" && (
                  <>
                    {filteredUsers?.map((user) => (
                      <a
                        href="#"
                        key={user.id}
                        className={`list-group-item list-group-item-action ${
                          user.unreadCount > 0 ? "unread" : ""
                        }`}
                        onClick={() => selectChatHandler(user, user.id)}
                      >
                        <div
                          className={`avatar ${
                            user.online ? "avatar-online" : "avatar-offline"
                          }`}
                        >
                          <img
                            src={
                              user.image ||
                              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAd5avdba8EiOZH8lmV3XshrXx7dKRZvhx-A&s"
                            }
                            alt={user.first_name}
                            className="avatar-img rounded-circle"
                          />
                        </div>
                        <div className="media-body d-flex flex-column justify-content-center ms-3">
                          <div className="chat-username">{user.full_name}</div>
                          <div className="chat-msg small">{user.message}</div>
                        </div>
                        {user.unreadCount > 0 && (
                          <div className="badge badge-success d-table">
                            {user.unreadCount}
                          </div>
                        )}
                      </a>
                    ))}
                  </>
                )}
                {activeTab === "group" && (
                  <>
                    {chatDonorGroup.map((group) => (
                      <a
                        href="#"
                        key={group.id}
                        className={`list-group-item list-group-item-action ${
                          group.unreadCount > 0 ? "unread" : ""
                        }`}
                        onClick={() => selectChatGroupHandler(group, group.id)}
                      >
                        <div
                          className={`avatar ${
                            group.online ? "avatar-online" : "avatar-offline"
                          }`}
                        >
                          <img
                            src={
                              group.image ||
                              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAd5avdba8EiOZH8lmV3XshrXx7dKRZvhx-A&s"
                            }
                            alt={group.first_name}
                            className="avatar-img rounded-circle"
                          />
                        </div>
                        <div className="media-body d-flex flex-column justify-content-center ms-3">
                          <div className="chat-username">
                            {group.donor_group_name}
                          </div>
                          <div className="chat-msg small">{group.message}</div>
                        </div>
                        {group.unreadCount > 0 && (
                          <div className="badge badge-success d-table">
                            {group.unreadCount}
                          </div>
                        )}
                      </a>
                    ))}
                  </>
                )}
                {activeTab === "broadcast" && (
                  <div className="p-3 text-center text-muted">
                    <i className="fas fa-bullhorn fa-2x mb-2"></i>
                    <p>Broadcast messages will appear here</p>
                    <p className="small">
                      Send a message without selecting a recipient to broadcast
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Right Part Chart Part */}
        <div className="page-inner page-inner-fill bg-white">
          <div className="conversations">
            <div className="message-header">
              {activeTab === "broadcast" ? (
                <div className="message-title">
                  <div className="user ms-2 d-flex align-items-center">
                    <div className="avatar avatar-group">
                      <i className="fas fa-bullhorn fa-2x text-primary"></i>
                    </div>
                    <div className="info-user ms-2">
                      <span className="name">Admin Broadcast</span>
                      <span className="last-active text-muted small">
                        Messages sent to all users
                      </span>
                    </div>
                  </div>
                </div>
              ) : activeTab === "donor" ? (
                selectedUser ? (
                  <div className="message-title">
                    <div className="user ms-2 d-flex align-items-center">
                      <div
                        className={`avatar ${
                          selectedUser.online
                            ? "avatar-online"
                            : "avatar-offline"
                        }`}
                      >
                        <img
                          src={
                            selectedUser.image ||
                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAd5avdba8EiOZH8lmV3XshrXx7dKRZvhx-A&s"
                          }
                          alt={selectedUser.first_name}
                          className="avatar-img rounded-circle border border-white"
                        />
                      </div>
                      <div className="info-user ms-2">
                        <span className="name">{selectedUser.full_name}</span>
                        <span className="last-active">
                          Active {selectedUser.last_active || "recently"}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="p-4 text-muted text-center">
                    Select a donor to start chat
                  </div>
                )
              ) : activeTab === "group" ? (
                selectedGroupUser ? (
                  <div className="message-title">
                    <div className="user ms-2 d-flex align-items-center">
                      <div className="avatar avatar-group">
                        <img
                          src={
                            selectedGroupUser.image ||
                            "https://cdn-icons-png.flaticon.com/512/3523/3523881.png"
                          }
                          alt={selectedGroupUser.donor_group_members_name}
                          className="avatar-img rounded-circle border border-white"
                        />
                      </div>
                      <div className="info-user ms-2">
                        <span className="name">
                          <p className="text-muted mb-0">
                            👥{" "}
                            {selectedGroupUser?.donor_group_members_name
                              ? selectedGroupUser.donor_group_members_name
                                  .split(",")
                                  .map((name) => name.trim())
                                  .slice(0, 3)
                                  .join(", ") +
                                (selectedGroupUser.donor_group_members_name.split(
                                  ",",
                                ).length > 5
                                  ? " +..."
                                  : "")
                              : "No Members"}
                          </p>
                        </span>
                        <span className="last-active text-muted small">
                          Group chat
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="p-4 text-muted text-center">
                    Select a donor group to start chat
                  </div>
                )
              ) : null}
            </div>

            {(selectedUser ||
              selectedGroupUser ||
              activeTab === "broadcast") && (
              <>
                {/*  Chat Messages */}
                <div className="conversations-body">
                  <div className="conversations-content bg-white">
                    {/* Merge and sort messages by created_at */}
                    {(() => {
                      // Combine messages based on current view
                      let allMessages = [];

                      if (activeTab === "broadcast") {
                        allMessages = broadcastMessages;
                      } else {
                        allMessages = message;
                      }

                      // Sort by created_at (newest first if you want, or oldest first)
                      return allMessages
                        .sort(
                          (a, b) =>
                            new Date(a.created_at) - new Date(b.created_at),
                        )
                        .map((msg, index) => {
                          const isBroadcast = isBroadcastMessage(msg);
                          const direction = isBroadcast
                            ? "in"
                            : getMessageDirection(msg);
                          const senderName = isBroadcast
                            ? "Admin"
                            : getSenderName(msg);

                          return (
                            <div
                              key={index}
                              className="message-content-wrapper"
                            >
                              <div
                                className={`message message-${direction} ${
                                  isBroadcast ? "broadcast-message" : ""
                                }`}
                              >
                                {direction === "in" && (
                                  <div className="avatar avatar-sm">
                                    <img
                                      src={
                                        isBroadcast
                                          ? "https://cdn-icons-png.flaticon.com/512/3523/3523881.png"
                                          : selectedUser?.image ||
                                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAd5avdba8EiOZH8lmV3XshrXx7dKRZvhx-A&s"
                                      }
                                      alt="..."
                                      className="avatar-img rounded-circle border border-white"
                                    />
                                  </div>
                                )}

                                <div className="message-body">
                                  <div
                                    className={`message-content ${
                                      isBroadcast ? "broadcast-content" : ""
                                    }`}
                                    style={{
                                      backgroundColor: isBroadcast
                                        ? "#fff3cd"
                                        : "#f5f5f5",
                                      border: isBroadcast
                                        ? "2px solid #ffc107"
                                        : "none",
                                      position: "relative",
                                    }}
                                  >
                                    {/* Show sender name for broadcast messages */}
                                    {isBroadcast && (
                                      <div className="broadcast-header d-flex align-items-center mb-1">
                                        <span className="badge bg-warning text-dark me-2">
                                          <i className="fas fa-bullhorn me-1"></i>
                                          Broadcast
                                        </span>
                                        <span className="sender-name fw-bold text-dark">
                                          {senderName}
                                        </span>
                                      </div>
                                    )}

                                    {!isBroadcast && direction === "in" && (
                                      <div className="name">
                                        {selectedUser?.full_name}
                                      </div>
                                    )}

                                    <div className="content">
                                      {renderMessageContent(msg)}
                                    </div>
                                  </div>

                                  <div className="date">
                                    {formatTime(msg.created_at || new Date())}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        });
                    })()}
                  </div>
                </div>

                {/* Chat Input Box */}
                <div className="messages-form">
                  <div className="messages-form-tool me-3">
                    {/* Dropdown Button */}
                    {role === "admin" && (
                      <div>
                        <div className="dropdown">
                          <button
                            className="btn btn-icon btn-round btn-light"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="fas fa-plus"></i>
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <li>
                              <button
                                type="button"
                                className="btn btn-round btn-light"
                                data-bs-toggle="modal"
                                data-bs-target="#customModal"
                                onClick={() => setMediaType("image")}
                              >
                                Upload Image
                                {/* <i className="fas fa-plus"></i> */}
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                className="btn btn-round btn-light"
                                data-bs-toggle="modal"
                                data-bs-target="#customModal"
                                onClick={() => setMediaType("video")}
                              >
                                Upload Video
                                {/* <i className="fas fa-plus"></i> */}
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}

                    {/* Modal Code */}
                    <div
                      className="modal fade"
                      id="customModal"
                      tabIndex="-1"
                      aria-labelledby="customModalLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog modal-lg modal-dialog-scrollable">
                        <div className="modal-content">
                          {/* Modal Header */}
                          <div className="modal-header">
                            <h5 className="modal-title" id="customModalLabel">
                              {mediaType === "video"
                                ? "Video Library"
                                : "Image Library"}
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>

                          {/* Modal Body */}
                          <div className="modal-body">
                            {/* Top Bar */}
                            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                              <input
                                type="text"
                                className="form-control w-50"
                                placeholder="Search media..."
                                // onChange={(e) => setSearch(e.target.value)}
                              />
                              <div className="d-flex align-items-center gap-2">
                                <select className="form-select">
                                  <option value="recent">
                                    Sort by: Recent
                                  </option>
                                  <option value="name">Sort by: Name</option>
                                </select>
                                <button
                                  onClick={() => changeGridHandler("rows")}
                                  className="btn btn-outline-secondary"
                                >
                                  <i className="fas fa-th-large"></i>
                                </button>
                                <button
                                  onClick={() => changeGridHandler("column")}
                                  className="btn btn-outline-secondary"
                                >
                                  <i className="fas fa-list"></i>
                                </button>
                              </div>
                            </div>

                            {/* Upload Section */}
                            <label
                              htmlFor="mediaUpload"
                              className="upload-section w-100 p-4 mb-4 rounded border border-2 border-dashed"
                              style={{
                                minHeight: "160px",
                                background: "#f9f9f9",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                flexDirection: "column",
                                cursor: "pointer",
                                transition:
                                  "background 0.3s, border-color 0.3s",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "#eaf3ff";
                                e.currentTarget.style.borderColor = "#0d6efd";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "#f9f9f9";
                                e.currentTarget.style.borderColor = "#ced4da";
                              }}
                            >
                              <h6 className="mb-2 fw-semibold">
                                Add {mediaType === "video" ? "Video" : "Image"}
                              </h6>
                              <p
                                className="text-muted mb-3"
                                style={{ maxWidth: "500px" }}
                              >
                                Upload{" "}
                                {mediaType === "video" ? "videos" : "images"} to
                                use in chat.
                              </p>

                              <span className="btn btn-outline-primary px-4 py-2">
                                📁 Upload{" "}
                                {mediaType === "video" ? "Video" : "Image"}
                              </span>

                              <input
                                type="file"
                                id="mediaUpload"
                                accept={
                                  mediaType === "video" ? "video/*" : "image/*"
                                }
                                style={{ display: "none" }}
                                // onChange={handleMediaUpload}
                                onChange={handleMediaUpload}
                              />
                            </label>

                            {/* Show the loading spinner if loading is true */}
                            {/* Show loading spinner for image upload OR progress bar for video upload */}
                            {mediaType === "image" ? (
                              loading && (
                                <div className="text-center my-3">
                                  <div
                                    className="spinner-border text-primary"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Uploading...
                                    </span>
                                  </div>
                                  <p>Uploading media, please wait...</p>
                                </div>
                              )
                            ) : (
                              <div
                                className={`progress mb-3 ${
                                  isUploading ? "" : "d-none"
                                }`}
                              >
                                <div
                                  className="progress-bar"
                                  id="add_video_progressbar_id"
                                  role="progressbar"
                                  style={{ width: `${uploadProgress}%` }}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  {uploadProgress}%
                                </div>
                              </div>
                            )}

                            {/* Modal Inside Contain Image and Video */}
                            {/* <div className="row g-3"> */}
                            <div
                              className={`${gridPosition === "row" ? "row" : "col gap-2"} g-3`}
                            >
                              {uploadedMedia
                                .filter((item) => item.media_type === mediaType)
                                .map((item, index) => {
                                  const isSelected =
                                    selectedItems.includes(index);
                                  return (
                                    <div className="col-6 col-md-3" key={index}>
                                      <div
                                        className={`border rounded p-2 text-center position-relative ${
                                          isSelected
                                            ? "border-primary bg-opacity-10"
                                            : ""
                                        }`}
                                        style={{
                                          cursor: "pointer",
                                          maxWidth: "180px",
                                          height: "130px",
                                          margin: "0 auto",
                                        }}
                                        onClick={() =>
                                          selectMediaFileToSend(
                                            index,
                                            item.thumbnail_url,
                                            item.media_url,
                                            item.media_type,
                                          )
                                        }
                                      >
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: "5px",
                                            left: "5px",
                                            width: "20px",
                                            height: "20px",
                                            backgroundColor: isSelected
                                              ? "#0d6efd"
                                              : "white",
                                            border: "2px solid #999",
                                            borderRadius: "4px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            zIndex: 2,
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            color: isSelected
                                              ? "white"
                                              : "transparent",
                                          }}
                                        >
                                          {isSelected && "✓"}
                                        </div>

                                        {item.media_type === "image" ? (
                                          <img
                                            src={item.thumbnail_url}
                                            alt={`media-${index}`}
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                              objectFit: "contain",
                                              borderRadius: "4px",
                                            }}
                                          />
                                        ) : (
                                          <video
                                            src={item.media_url}
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                              objectFit: "contain",
                                              borderRadius: "4px",
                                            }}
                                            muted
                                            loop
                                            playsInline
                                          />
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                              >
                                Cancel
                              </button>

                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSubmit}
                                disabled={!selectedPreview}
                              >
                                {mediaType === "video"
                                  ? "Send Video"
                                  : "Send Image"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Post Modal */}

                  <div
                    className="modal fade"
                    id="postModal"
                    tabIndex="-1"
                    aria-labelledby="postModalLabel"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered ">
                      <div className="modal-content">
                        <div className="d-flex justify-content-end p-2">
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <div className="row">
                            <div className="col-md-12 col-sm-12 mb-2">
                              {selectedPost?.media_type === "image" ? (
                                <img
                                  src={selectedPost.thumbnail_url}
                                  className="img-fluid rounded"
                                  alt="Selected"
                                  style={{
                                    width: "100%",
                                    maxHeight: "30vh",
                                    objectFit: "contain",
                                  }}
                                />
                              ) : (
                                <video
                                  id="player"
                                  className="w-100 rounded shadow-sm"
                                  controls
                                  src={selectedPost?.media_url}
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "30vh",
                                  }}
                                ></video>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Chat Footer Part */}

                  <div className="messages-form-control flex-grow-1">
                    <input
                      type="text"
                      placeholder="Type a message..."
                      className="form-control input-pill input-solid message-input"
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      onKeyDown={(e) =>
                        e.key === "Enter" && newMessage.trim() && handleSubmit()
                      }
                    />
                  </div>

                  <div className="messages-form-tool ms-2">
                    <button
                      type="button"
                      className="btn btn-icon btn-round btn-primary"
                      onClick={handleSubmit}
                      disabled={!newMessage.trim() && !mediaFile}
                    >
                      <i className="fas fa-paper-plane"></i>
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Conversation;
